export default __webpack_public_path__ + "static/media/setup_img2.91c4bda0.png";